export const advancedDashletHeight = 1583;
export const advancedDashletImageWidth = 2256;
export const advancedDashletGraphHeight = 1083;
export const advancedDashletCanvasWidth = 1800;
export const advancedDashletBorderRadius = 33;
